import React from 'react'
import PropTypes from 'prop-types'
import { EMPTY } from './detailFormat'

// A headline number with its unit, for the summary row of a detail screen.
const DetailStatComponent = ({ label, value, unit, source, action }) => (
  <div className="detail-field">
    <div className="detail-label" title={source}>
      {label}
      {action && <span className="detail-action ms-2">{action}</span>}
    </div>
    <div className="detail-stat">
      {value === undefined || value === null || value === '' ? EMPTY : value}
      {unit && value !== EMPTY && <span className="detail-stat-unit">{unit}</span>}
    </div>
  </div>
)

DetailStatComponent.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node,
  unit: PropTypes.string,
  source: PropTypes.string,
  action: PropTypes.node
}

export default DetailStatComponent
